module.exports = __webpack_public_path__ + "img/about.3f16cc40.png";